
import { Component, Input, EventEmitter, Output, KeyValueDiffer, DoCheck, KeyValueDiffers } from "@angular/core";
import { Mensagem } from 'shared/entities/mensagem.entity';

@Component({
    selector: "exibe-erro",
    templateUrl: "./exibe-erro.component.html",
})
export class ExibeErroComponent implements DoCheck {
    constructor(private keyValueDiffers: KeyValueDiffers) 
    {
        this.keyValueDiffer = keyValueDiffers.find({}).create(); 
    }
    @Input() Erros: Mensagem[];
    @Input() Campo: string;
    @Input() input: HTMLInputElement;
    keyValueDiffer: KeyValueDiffer<any, any>;

    ngDoCheck() {
        let diff = this.keyValueDiffer.diff(this);

        
        
        if (diff && this.input && this.input.classList) {
            this.input.classList.remove('is-invalid');
            if (this.ExistirMensagemComponente(this.Campo))  
            {
                this.input.classList.add('is-invalid');
            }
        }
    }

    public ExistirMensagemComponente(NomeCampo: string): boolean {
        return this.Erros.some(d => d.Campo.some(e => e == NomeCampo));
    }

    public RetornarMensagensCampo(NomeCampo: string): string[] {
        return this.Erros.filter(d => d.Campo.some(e => e == NomeCampo)).map(d => d.Texto);
    }

    public RetornarCorFonte(NomeCampo: string): string {        
        if (NomeCampo == 'Valor') {
            return '#FFFF00';        
        }
    }

}
